import { IDeviceTreeGroupElement, IDeviceGroup } from "@types"
import { Box } from "theme-ui"
interface props {
 group: IDeviceGroup
 setSelectedDeviceTreeGroupElements: (..._arg: any[]) => void

 selectedDeviceTreeGroupElements: IDeviceTreeGroupElement[]
}
export const SideBarInnerCategory = ({
 group,
 selectedDeviceTreeGroupElements,
 setSelectedDeviceTreeGroupElements,
}: props) => {
 // Toggle Select device
 const toggleSelectDevice = (deviceTreeGroupElement: IDeviceTreeGroupElement) => {
  const deviceExistInCurrentSelection = selectedDeviceTreeGroupElements.find(
   (deviceObj: IDeviceTreeGroupElement) =>
    deviceObj.device_id === deviceTreeGroupElement.device_id &&
    deviceObj.group_id === deviceTreeGroupElement.group_id &&
    deviceObj.server_id === deviceTreeGroupElement.server_id,
  )
  if (deviceExistInCurrentSelection) {
   const selectedDeviceTreeGroupElementsDup = [...selectedDeviceTreeGroupElements].filter(
    (deviceObj: IDeviceTreeGroupElement) =>
     deviceObj.device_id !== deviceTreeGroupElement.device_id ||
     deviceObj.group_id !== deviceTreeGroupElement.group_id ||
     deviceObj.server_id !== deviceTreeGroupElement.server_id,
   )
   setSelectedDeviceTreeGroupElements(selectedDeviceTreeGroupElementsDup)
  } else {
   setSelectedDeviceTreeGroupElements([...selectedDeviceTreeGroupElements, deviceTreeGroupElement])
  }
 }

 const selectOnlyThisDevice = (deviceTreeGroupElement: IDeviceTreeGroupElement) => {
  setSelectedDeviceTreeGroupElements([{ ...deviceTreeGroupElement }])
 }
 return (
  <ul>
   {group?.devices.map((device: IDeviceTreeGroupElement, deviceIndex: number) => {
    const findDeviceTreeGroupElement: boolean = !!selectedDeviceTreeGroupElements.find(
     (deviceObj: IDeviceTreeGroupElement) =>
      deviceObj.device_id === device.device_id &&
      deviceObj.group_id === device.group_id &&
      deviceObj.server_id === device.server_id,
    )
    return (
     <Box key={deviceIndex} color="text">
      <div className="w-11/12 mx-auto pl-10 animate-move-card" key={deviceIndex}>
       <div className="subcategory gap-2 pl-2 flex py-2 ">
        <div
         className={` h-4 w-4 rounded  flex justify-center mt-1 ${
          device.status === "active"
           ? "bg-red"
           : device.status === "inactive"
             ? "bg-golden"
             : device.status === "failure"
               ? "bg-green"
               : ""
         }`}
        />

        <div className="w-full gap-2 flex">
         <span
          className={`  h-5 w-5 rounded flex justify-center items-center cursor-pointer ${
           findDeviceTreeGroupElement === true ? "bg-golden border border-yellow" : " bg-gray"
          }`}
          onClick={() => toggleSelectDevice(device)}
         >
          {findDeviceTreeGroupElement && (
           <span className="flex w-full items-center justify-center">✔</span>
          )}
         </span>
         <label
          className="font-normal cursor-pointer w-4/5 text-sm pt-[2px] Jakarta-font"
          onClick={() => selectOnlyThisDevice(device)}
         >
          {device.device_name}
         </label>
        </div>
       </div>
      </div>
     </Box>
    )
   })}
  </ul>
 )
}
